<!-- header -->
<app-app-nav></app-app-nav>

<!-- END header -->

<main id="mainContent" tabindex="-1" class="">
  <!-- whatsapp floating button -->
  <app-whatsapp></app-whatsapp>
  <!-- END whatsapp floating button -->
  <div class="container-fluid position-relative">
    <div class="row bg-secondary py-4">
      <div class="col">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb animate__animated animate__fadeInDown mb-0">
            <li class="breadcrumb-item mb-2 mb-md-0">
              <a class="text-white" routerLink="/">أكادميه الفنون</a>
            </li>
            <!-- <li class="breadcrumb-item mb-2 mb-md-0">
              <a class="text-white" href="faculty.html">معهد السينما</a>
            </li> -->
            <li class="breadcrumb-item mb-2 mb-md-0">
              <a class="text-white" (click)="go_to_news()" role="button" tabindex="0" (keydown.enter)="go_to_news()" (keydown.space)="go_to_news()">
                أخبار
              </a>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
                {{ new_data.TITLE }}
            </li>
          </ol>
        </nav>
      </div>
    </div>
    <section
      class="row pb-5 pt-4  animate__animated animate__fadeIn animate__fast wow"
    >
      <div class="col-lg-8 col-xl-9 ps-lg-4 course-details">
        <!-- <div class="pb-4 fw-medium animate__fadeInDown animate__faster wow">
          العودة إلى
          <a class="text-primary"
            >المعهد العالي للسينما <i class="icon-arrow-sm default"></i
          ></a>
        </div> -->
        <h1>{{ new_data.TITLE }}</h1>
        <!-- <h6 class="fw-medium mb-0">
          بواسطه مصطفى طاهر
        </h6> -->
        <!-- <label
          class="badge bg-primary-light py-1 px-2 lh-base text-black d-sm-none d-inline-block mt-2"
        >
          سينما
        </label> -->
        <div class="position-relative mt-4">
                <img src="{{new_data.IMG_PATH}}" alt="" />
          <div
            class="bg-white p-3  start-0 d-md-flex align-items-center date-details" >
            <div class="d-flex me-3 align-items-center">
              <i class="icon-calender text-primary me-2"></i>
              <div class="date d-flex flex-column ">
                <label class="fw-medium">تاريخ النشر</label>
                <p class="fw-medium mb-0">{{new_data.NEW_DATE | date:'yyyy/MM/dd'}}</p>
              </div>
            </div>
            <label
              *ngIf="new_data.FACULTY_NAME"
              class="badge bg-primary-light py-1 px-2 lh-base text-black d-sm-inline-block d-none"
            >
              {{new_data.FACULTY_NAME}}
            </label>
          </div>
        </div>
        <div class="position-relative pt-4">
          <div class="mb-4">
            <p class="text-muted fw-medium news-body">
             {{new_data.DETAILS}}
            </p>
          </div>

          <!-- Attachment gallery (NEW_IMGS) -->
          <div class="news-gallery" *ngIf="gallery.length">
            <h3 class="news-section-title heading-font">صور من الخبر</h3>
            <div class="news-gallery-grid">
              <div class="news-gallery-item" *ngFor="let img of gallery" data-bs-toggle="modal"
                data-bs-target="#newsImageModal" (click)="openImage(img)" role="button" tabindex="0" (keydown.enter)="openImage(img)" (keydown.space)="openImage(img)">
                <img [src]="img" alt="صورة من الخبر" loading="lazy" />
              </div>
            </div>
          </div>

          <!-- Embedded videos (NEW_VIDEOS) -->
          <div class="news-videos" *ngIf="videos.length">
            <h3 class="news-section-title heading-font">فيديوهات</h3>
            <div class="news-videos-grid">
              <div class="news-video-item" *ngFor="let video of videos">
                <div class="news-video-frame">
                  <iframe [src]="video.url" frameborder="0" loading="lazy"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen [title]="video.title || 'فيديو الخبر'"></iframe>
                </div>
                <p class="news-video-title" *ngIf="video.title">{{video.title}}</p>
              </div>
            </div>
          </div>

          <!-- Related links (NEW_LINKS) -->
          <div class="news-links" *ngIf="links.length">
            <h3 class="news-section-title heading-font">روابط ذات صلة</h3>
            <ul class="news-links-list">
              <li *ngFor="let link of links">
                <a [href]="link.url" target="_blank" rel="noopener noreferrer">
                  <svg class="news-link-icon" width="18" height="18" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path>
                    <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path>
                  </svg>
                  <span>{{link.title}}</span>
                </a>
              </li>
            </ul>
          </div>

          <!-- Keywords (NEW_KEY_WORDS) -->
          <div class="news-keywords" *ngIf="keywords.length">
            <h3 class="news-section-title heading-font">كلمات مفتاحية</h3>
            <div class="news-tags">
              <span class="news-tag" *ngFor="let tag of keywords">{{tag}}</span>
            </div>
          </div>

        </div>
        <!-- <div class="border-top border-bottom mt-5 py-1 d-flex">
          <ul class="list-inline mb-0 d-flex align-items-center">
            <li class="list-inline-item">
              <button class="btn border-0 px-1">
                <img src="assets/img/fb.svg" alt="" />
              </button>
            </li>
            <li class="list-inline-item">
              <button class="btn border-0 px-1">
                <img src="assets/img/twitter.svg" alt="" />
              </button>
            </li>
            <li class="list-inline-item">
              <button
                class="btn border-0 text-black fw-medium px-1 share-btn d-flex align-items-center dropdown-toggle dropdown-toggle-split"
                type="button"
                id="dropdownShare"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i class="icon-share d-inline-block me-1"></i>
                شارك البحث
              </button>
              <ul
                class="dropdown-menu border shadow p-0 dropdown-share"
                aria-labelledby="dropdownShare"
              >
                <li>
                  <a
                    class="dropdown-item border-bottom fw-medium  d-flex align-items-center"
                    href="#"
                  >
                    <i class="icon-email d-inline-block me-2 text-muted"></i>
                    بريد إلكتروني
                  </a>
                </li>
                <li>
                  <a
                    class="dropdown-item fw-medium d-flex align-items-center"
                    href="#"
                  >
                    <i class="icon-copy d-inline-block me-2 text-muted"></i>
                    نسخ الرابط
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </div> -->
      </div>
      <aside class="col-lg-4 col-xl-3 mt-lg-5 pt-5">
        <div class="border px-3 pt-4">
          <h3>أخبار أكثر قراءة</h3>
          <ul class="list-unstyled fw-medium fs-7">
            <li class="border-top py-4 px-1" *ngFor="let item of top_readed">
              <a class="text-black hover" (click)="newsDetails(item)" role="button" tabindex="0" (keydown.enter)="newsDetails(item)" (keydown.space)="newsDetails(item)">{{item.TITLE}} </a>
            </li>
          </ul>
        </div>
        <!-- <div class="text-center w-100 overflow-hidden pt-5">
          <img src="assets/img/300x600.jpg" alt="" />
        </div> -->
      </aside>
    </section>
  </div>
  <section class="container-fluid pt-lg-5 pt-3 pb-lg-5 pb-3">
    <div class="row">
      <div
        class="col-lg-3 col-md-6 mb-lg-0 mb-3 pb-lg-0 pb-3 animate__animated animate__fadeInUp animate__faster wow"
      >
        <a
          class="btn caption border d-flex align-items-center text-start p-3 fs-6 h-100"
        >
          <div class="fw-medium flex-fill p-1">
            موقع الطالب
            <p class="mb-0 text-gray mt-1">
              تعرف على المواد و المهام و النتيجة
            </p>
          </div>
          <i class="icon-arrow-sm m-1 default d-block overflow-hidden"></i>
        </a>
      </div>
      <div
        class="col-lg-3 col-md-6 mb-lg-0 mb-3 pb-lg-0 pb-3 animate__animated animate__fadeInUp animate__fast wow"
      >
        <a
          class="btn caption border d-flex align-items-center text-start p-3 fs-6 h-100"
        >
          <div class="fw-medium flex-fill p-1">
            موقع هيئة التدريس
            <p class="mb-0 text-gray mt-1">تابع متطلبات الطلبه</p>
          </div>
          <i class="icon-arrow-sm m-1 default d-block overflow-hidden"></i>
        </a>
      </div>
      <div
        class="col-lg-3 col-md-6 mb-lg-0 mb-3 pb-lg-0 pb-3 animate__animated animate__fadeInUp animate__fast wow"
      >
        <a
          class="btn caption border d-flex align-items-center text-start p-3 fs-6 h-100"
        >
          <div class="fw-medium flex-fill p-1">
            موقع الموظفين
            <p class="mb-0 text-gray mt-1">تابع متطلبات الطلبه</p>
          </div>
          <i class="icon-arrow-sm m-1 default d-block overflow-hidden"></i>
        </a>
      </div>
      <div
        class="col-lg-3 col-md-6 mb-lg-0 mb-3 pb-lg-0 pb-3 animate__animated animate__fadeInUp wow"
      >
        <a
          class="btn caption border d-flex align-items-center text-start p-3 fs-6 h-100"
        >
          <div class="fw-medium flex-fill p-1">
            خدمات الخريجين
            <p class="mb-0 text-gray mt-1">
              تعرف على الخدمات الخاصه بالخرجين
            </p>
          </div>
          <i class="icon-arrow-sm m-1 default d-block overflow-hidden"></i>
        </a>
      </div>
    </div>
  </section>
</main>

<!-- Image lightbox -->
<div class="modal fade news-image-modal" id="newsImageModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-xl modal-dialog-centered">
    <div class="modal-content">
      <button type="button" class="news-image-close" data-bs-dismiss="modal" aria-label="إغلاق">
        <span aria-hidden="true">&times;</span>
      </button>
      <div class="modal-body p-0">
        <img class="w-100" [src]="src_image" alt="صورة من الخبر">
      </div>
    </div>
  </div>
</div>
